// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 9 13" {...rest} unit={unit}>
		<g transform="translate(-26.000000, -24.000000)">
			<polygon points="34.9477201 26.7142857 29.336588 26.7142857 29.336588 29.0267857
			34.0538331 29.0267857 34.0538331 31.6339286 29.336588 31.6339286 29.336588
			34.3035714 34.9388698 34.3035714 34.9388698 37 26 37 26 24 34.9477201 24" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/E.js